import {
    GetUnCoopVisitorListUsingGet1Params,
    UnCoopVisitorInfoVo,
    QueryVisitorCountByPeriodUsingGet1Params,
    VisitorCountVo,
    ChannelMainPlatformCategoryVo,
    QueryNoCoopVisitorCountUsingGet2Params,
    NoCoopVisitorCountVo,
    SupplierAuditConfigVo,
    MultiChannelsParam,
    QueryStatisticsSummaryUsingGet1Params,
    StatisticsSummaryVo,
    QueryStatisticsSummaryTrendUsingGet1Params,
    StatisticsSummaryTrendVo,
    VisitorUpdatedInfoVo,
    ListSupplierSaleManResult,
} from '@servicesTypings/drpRequest'
import { drpRequest } from '@/utils/request'
import { getCacheService } from '@/utils/requestUtils'

// 获取主营平台
/**
 * 获取主营平台
 */
export function getMainPlatformList(): API.Res<string[]> {
    return drpRequest.get('/channelCustomerCenter/getMainPlatformList')
}

// 获取分销平台
/**
 * swagger找不到此接口
 */
export function getDisPlatformList(params) {
    return drpRequest.get('/channelCustomerCenter/getDisPlatformList', {
        params,
    })
}

/**
 * 获取分销合作筛选下拉
 */
export function getDisCoopSelect(params) {
    const drpRequestCache = getCacheService(drpRequest)
    return drpRequestCache.get('/channelCustomerCenter/getDisCoopSelect', {
        params,
    })
}

// 获取销售类目
export function getDisCategoryList(params) {
    const drpRequestCache = getCacheService(drpRequest)
    return drpRequestCache.get('/channelCustomerCenter/getCategoryList', {
        params,
    })
}

// 获取未合作访客列表
/**
 * 查询未合作访客信息列表
 */
export function getUnCoopVisitorList(params: GetUnCoopVisitorListUsingGet1Params): API.Res<UnCoopVisitorInfoVo[]> {
    return drpRequest.get('/visitorInfo/getUnCoopVisitorList', { params })
}

// 根据统计周期查询访客统计
/**
 * 根据统计周期查询访客统计
 */
export function queryVisitorCountByPeriod(params: QueryVisitorCountByPeriodUsingGet1Params): API.Res<VisitorCountVo> {
    return drpRequest.get('/visitorInfo/queryVisitorCountByPeriod', { params })
}

// 获取销售平台与一二级类目
/**
 * 获取销售平台与一二级类目
 */
export function getMainPlatformCategoryList(): API.Res<ChannelMainPlatformCategoryVo> {
    return drpRequest.get('/visitorInfo/getMainPlatformCategoryList')
}

// 获取找货需求下拉选项
/**
 * 获取找货需求下拉选项
 */
export function getWfgDemandList(): API.Res<string[]> {
    return drpRequest.get('/visitorInfo/getWfgDemandList')
}

// 根据统计周期查询未合作访客统计
/**
 * 根据统计周期查询未合作访客统计
 */
export function queryNoCoopVisitorCount(params: QueryNoCoopVisitorCountUsingGet2Params): API.Res<NoCoopVisitorCountVo> {
    return drpRequest.get('/visitorInfo/queryNoCoopVisitorCount', { params })
}

// 批量申请或审核时的默认值获取
/**
 * 供应商审核时查询配置
 */
export function querySupplierAuditConfig(): API.Res<SupplierAuditConfigVo> {
    return drpRequest.get('/disConfig/querySupplierAuditConfig')
}

// 批量向分销商发起合作申请
export function batchApply(data) {
    return drpRequest.post('/partner/supplier/batchApply', { data })
}

// 批量同意分销商的申请，建立合作关系
export function batchConfirm(data) {
    return drpRequest.post('/partner/supplier/batchConfirm', { data })
}

// 供应商批量修改催促合作时间
/**
 * 供应商批量修改催促合作时间
 */
export function supplierBatchUpdateUrgeTime(data: MultiChannelsParam): API.Res<object> {
    return drpRequest.post('/partner/supplier/supplierBatchUpdateUrgeTime', { data })
}

// 合作商家分销总览
/**
 * 合作商家分销汇总指标卡
 */
export function queryStatisticsSummary(params: QueryStatisticsSummaryUsingGet1Params): API.Res<StatisticsSummaryVo> {
    return drpRequest.get('/channelCustomerCenter/queryStatisticsSummary', { params })
}

// 合作商家分销总览趋势图
/**
 * 分销总览对应趋势图
 */
export function queryStatisticsSummaryTrend(
    params: QueryStatisticsSummaryTrendUsingGet1Params,
): API.Res<StatisticsSummaryTrendVo[]> {
    return drpRequest.get('/channelCustomerCenter/queryStatisticsSummaryTrend', { params })
}

// 访客管理更新信息
/**
 * 访客管理更新信息
 */
export function getVisitorUpdatedInfo(): API.Res<VisitorUpdatedInfoVo> {
    return drpRequest.get('/visitorInfo/getVisitorUpdatedInfo')
}

// 查询供应商业务员信息
/**
 * 查询供应商业务员信息
 */
export function queryListSupplierSaleMan(data: string[]): API.Res<ListSupplierSaleManResult[]> {
    return drpRequest.post('/partner/supplier/listSupplierSaleMan', { data })
}
